import { render } from "./DefaultBatchTopInfo.vue?vue&type=template&id=49e4e035"
import script from "./DefaultBatchTopInfo.vue?vue&type=script&lang=js"
export * from "./DefaultBatchTopInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__